// @ts-nocheck
import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

interface ColumnTooltipProps {
  content: string;
}

export const ColumnTooltip: React.FC<ColumnTooltipProps> = ({ content }) => {
  const { isDark } = useTheme();
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block ml-1">
      <button
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onClick={(e) => {
          e.stopPropagation();
          setIsVisible(!isVisible);
        }}
        className={`p-0.5 rounded hover:bg-opacity-20 transition-colors ${
          isDark ? 'hover:bg-white' : 'hover:bg-gray-600'
        }`}
      >
        <HelpCircle className={`w-3.5 h-3.5 ${
          isDark ? 'text-gray-400' : 'text-gray-500'
        }`} />
      </button>

      {isVisible && (
        <div
          className={`absolute z-50 w-64 p-3 text-xs rounded-lg shadow-lg border ${
            isDark
              ? 'bg-zinc-800 border-zinc-700 text-gray-200'
              : 'bg-white border-gray-200 text-gray-700'
          } left-0 top-full mt-1`}
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
        >
          <div className="absolute -top-1 left-4 w-2 h-2 transform rotate-45 ${
            isDark ? 'bg-zinc-800 border-l border-t border-zinc-700' : 'bg-white border-l border-t border-gray-200'
          }"></div>
          {content}
        </div>
      )}
    </div>
  );
};
